module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-phone"
  }, [_c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('CountryCode', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "sendCountryCode": _vm.sendCountryCode
    }
  }), _vm._v(" "), _c('Inputs', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": 'phone'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('Inputs', {
    staticStyle: {
      "width": "180px",
      "margin-top": "0",
      "float": "left"
    },
    attrs: {
      "type": 'code'
    },
    on: {
      "inputText": _vm.getCode,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('GetCode', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": 0,
      "data": {
        countryCode: _vm.countryCode,
        phone: _vm.phone
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('Buttons', {
    staticStyle: {
      "width": "140px",
      "float": "left",
      "margin-top": "0"
    },
    attrs: {
      "type": 'back'
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "width": "140px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": 'done',
      "data": _vm.data
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.verifyLater()
      }
    }
  }, [_vm._v("Skip and verify later")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07b191fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/login/Signupphone.vue
// module id = 758
// module chunks = 1